import React, { Component } from 'react'
import Dialog from "./../../../../../components/dialog-base"


interface IZoomPopUpProps {
    onClose: () => void
    url: string
    id: string
}

class ZoomPopUp extends React.Component<IZoomPopUpProps> {

    render() {
        return <Dialog onClose={this.props.onClose}>
            <div>
                <img className="dialogClose" onClick={this.props.onClose} src="/local/templates/sign_plus/images/close.svg" alt=""/>
                <div className="dialogContaine__inner" id={this.props.id}>
                    <img src={this.props.url}/>
                </div>
            </div>
        </Dialog>
    }
}

export default ZoomPopUp